import { ColumnHelper } from "@tanstack/react-table";
import { getAPIFilters } from "PFApp/use_filtered_collection/format_filters";
import Table from "PFComponents/table";
import { getProfileName } from "PFCore/helpers/profile";
import useStorage from "PFCore/helpers/use_storage";
import { useBookingConfigProfileCalendars } from "PFCore/hooks/queries/bookings/booking_config/use_booking_config_profile_calendars";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { WrappedLoadingDots } from "PFOutlook/src/components/wrapped_loading_dots/wrapped_loading_dots";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import css from "../../booking_calendars.module.scss";
import { FilterMode, Filters } from "../filters";

type Profile = {
  profile: { first_name: string; last_name: string; id: number };
  profile_calendars: { id: number; calendar_id: number; start_date: string }[];
};

const Assignees = (): JSX.Element => {
  const { formatDate } = useDateFormatter();
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useStorage("adminBookingCalendarAssignees", {});

  const params: { id: string } = useParams();
  const { data: profileCalendars, isLoading } = useBookingConfigProfileCalendars(
    params.id,
    getAPIFilters(filters),
    page
  );
  const { t } = useTranslation("bookingModule");

  const columns = (columnHelper: ColumnHelper<Profile>) => [
    columnHelper.accessor("profile", {
      id: "profile-name",
      header: t("config.calendars.workforce.name"),
      cell: (info) => getProfileName(info.getValue()),
      enableSorting: false
    }),
    columnHelper.accessor("profile_calendars", {
      id: "profile-calendars",
      header: t("config.calendars.workforce.start"),
      cell: (info) => {
        const startDates = info.getValue();
        return (
          <div className={css.calendarsGridCell}>
            {startDates.map((date) => (
              <div key={date.id}>{formatDate(date.start_date)}</div>
            ))}
          </div>
        );
      },
      enableSorting: false
    })
  ];

  if (isLoading) {
    return <WrappedLoadingDots circlesEnabled />;
  }

  const paginationOptions = {
    currentPage: profileCalendars?.meta?.page,
    onClick: setPage,
    totalPages: profileCalendars?.meta?.totalPages
  };

  return (
    <div className={css.assigneesContainer}>
      <Filters
        meta={profileCalendars?.meta}
        onFiltersChange={setFilters}
        isLoading={isLoading}
        mode={FilterMode.Assigness}
      />
      <Table<Profile>
        tableData={profileCalendars?.entries}
        generateColumns={columns}
        paginationOptions={paginationOptions}
      />
    </div>
  );
};

export default Assignees;
